import React from 'react'
import classnames from 'classnames'
import { Loading } from '@myxplor/ui'

import ListDisplay from './display'
import PrimaryListWrapper from './primary-list-wrapper'
import Empty from './empty'
import './lists.css'

const showList = num => num > 1

const List = ({
  records = [],
  recordsTotal = 0,
  loading,
  currentRecordID,
  base_url,
  component,
  children,
  primaryKey = ({ id }) => id,
  filterDisabled,
  filterTerm,
  filterOnChange,
  className,
  emptyComponent = Empty,
}) => {
  if (!loading && recordsTotal === 0) {
    return <PrimaryListWrapper>{React.createElement(emptyComponent)}</PrimaryListWrapper>
  }

  return (
    <div
      className={classnames({
        listWrapper: true,
        'listWrapper--selected': currentRecordID,
        'listWrapper--filter': !filterDisabled,
        [className]: className,
      })}>
      {loading ? (
        <Loading />
      ) : (
        showList(recordsTotal) && (
          <ListDisplay
            records={records}
            currentRecordID={currentRecordID}
            base_url={base_url}
            component={component}
            primaryKey={primaryKey}
            filterDisabled={filterDisabled}
            filterTerm={filterTerm}
            filterOnChange={filterOnChange}
          />
        )
      )}

      {children}
    </div>
  )
}

export default List



// WEBPACK FOOTER //
// ./src/ui/list/views/index.jsx